import React from 'react';
import { Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAppSelector } from '../../store/hooks';

export const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const loading = useAppSelector((s) => s.auth.loading);
  const user = useAppSelector((s) => s.auth.user);
  const { t } = useTranslation();

  if (loading) {
    return <div className="min-h-screen flex items-center justify-center bg-gray-100 text-gray-700">{t('app.loading')}</div>;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};
